import { useState } from "react";
import { Apis } from "../../../lib/Apis";
import axios from "axios";
import Swal from "sweetalert2";

export const useProducts = () => {
    const [loading, setLoading] = useState(false);
    const getProducts = async (setProducts) => {
        try {
            const response = await Apis.getProducts();
            if (response && response.data && Array.isArray(response.data.products)) {
                setProducts(response.data.products);
            } else {
                console.error("Invalid response format:", response);
            }
        } catch (error) {
            console.error("Error in Hook:", error.message || error);
        }
    };

    const getProductsWithPagination = async (setProducts, setTotal, offset = 0, limit = 20, searchQuery = "", statusFilter = "", categoryName = "") => {
        setLoading(true);
        try {
            const params = {};

            if (statusFilter !== "") {
                params.status = statusFilter === "true" ? true : false;
            }

            if (searchQuery && searchQuery.trim()) {
                params.name = searchQuery.trim();
            }

            if (categoryName && categoryName.trim()) {
                params.categoryName = categoryName.trim();
            }

            const response = await Apis.getProductsWithPagination(offset, limit, params);
            if (response?.status === 200) {
                setProducts(response.data.products);
                const totalRecords = response.data.pagination?.totalRecords || response.data.products.length;
                setTotal(totalRecords);
                return response.data;
            } else {
                throw new Error(response?.data?.message || "Failed to fetch products.");
            }
        } catch (error) {
            console.error("Error fetching products:", error);
            throw new Error(error.message || "Error fetching products.");
        } finally {
            setLoading(false);
        }
    };

    const getCategories = async (setCategories) => {
        try {
            const response = await Apis.getCategoriesToAddProducts();
            if (
                response &&
                response.data &&
                Array.isArray(response.data.categories)
            ) {
                setCategories(response.data.categories);
            } else {
                console.error("Invalid response format:", response);
                setCategories([]);
            }
        } catch (error) {
            console.error("Error fetching categories:", error?.message || error);
            setCategories([]);
        }
    };
    const updateProductStatus = async (id, status) => {
        try {
            setLoading(true);
            const requestBody = {
                id,
                status,
            };
            const response = await Apis.updateProductStatus(requestBody);
            if (response && response.data) {
                return response;
            } else {
                console.error("Invalid response format:", response);
                return null;
            }
        } catch (error) {
            console.error("Error in Hook:", error.message || error);
            return null;
        } finally {
            setLoading(false);
        }
    };
    const deleteProduct = async (id) => {
        try {
            const response = await Apis.deletProduct(id);
            if (response && response.data) {
                return response;
            } else {
                console.error("Invalid response format:", response);
                return null;
            }
        } catch (error) {
            console.error("Error in Hook:", error.message || error);
            return null;
        }
    };
    const addProduct = async (formData) => {
        try {
            const response = await Apis.addProduct(formData);
            return response.data;
        } catch (error) {
            console.error(error);
            throw error; // Re-throw the error so the component can handle it
        }
    };
    const updateProduct = async (updateId, data) => {
        try {
            const response = await Apis.updateProduct(updateId, data);
        } catch (error) {
            console.error(error);
        }
    };
    const getBrands = async (setBrandsData) => {
        try {
            const response = await Apis.getBrands();
            setBrandsData(response.data);
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    const updateProductPosition = async (productId, newPosition) => {
        try {
            const response = await Apis.updateProductPosition(productId, newPosition);
            return response?.data ?? response;
        } catch (error) {
            console.error("Error in Hook:", error.message || error);
            throw error;
        }
    };

    return {
        getProducts,
        getProductsWithPagination,
        getCategories,
        updateProductStatus,
        deleteProduct,
        addProduct,
        updateProduct,
        getBrands,
        updateProductPosition
    };
};

export default useProducts;